import React from "react";
import "../styles/locateus.css"
import "../styles/contactus.css";

export default class LocateUs extends React.Component {
    render() {
        return (
                <div className="container-my">
                    <div className="location-details">
                        <div className="content-locate">
                            <div className="heading-locate">
                                GET YOUR FREE QUOTE TODAY!
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-4 col-lg-4 padding-around">
                                    <p className="sub-section">ADDRESS</p>
                                    <p className="contact-section">A-001,Chandresh Terrace CHS Ltd.,</p>
                                    <p className="contact-section">Near Sai Petrol Pump,Parshwa Nagar, </p>
                                    <p className="contact-section">Mira Road(East),Thane 401107</p>
                                    <p className="contact-section">Maharashtra,India</p>
                                </div>
                                <div className="col-sm-12 col-md-4 col-lg-3 padding-around">
                                    <p className="sub-section">WORKING HOURS</p>
                                    <p className="contact-section">Monday - Saturday </p>
                                    <p className="contact-section">10.30 AM to 6 PM IST</p>
                                </div>
                                <div className="col-sm-12 col-md-4 col-lg-4 padding-around">
                                    <p className="sub-section">CONTACT</p>
                                    <p className="contact-section">
                                        <i className="fa fa-phone"/><span
                                        className="light-padding">Phone: +91 9892079970</span></p>
                                    <p className="contact-section">
                                        @ Email: casiddharthsdwivedi@gmail.com</p>
                                    <p className="contact-section">
                                        <a href="https://wa.me/919892079970">
                                            <i className="fa fa-whatsapp"/><span
                                            className="light-padding">WhatsApp: +91 9892079970</span></a>
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
        )
    }
}